import React, { useState, forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import Papa from 'papaparse';
import { Container, ButtonGroup } from 'react-bootstrap';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import apiService from '../../../Auth/apiService';
import MenuAdministrativosRei from './MenuAdministrativosRei';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from '../../../Auth/AuthContext';
import { FaCalendar, FaSearch } from 'react-icons/fa';

const CustomInput = forwardRef(function CustomInput({ value, onClick }, ref) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(e);
        }
    };
    return (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            onKeyDown={handleKeyDown}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input
                value={value}
                readOnly
                className='widthCalendar'
                data-tooltip-id='tooltiparriba'
                data-tooltip-content="Seleccione fecha"
                tabIndex={-1}
                aria-readonly="true"
                style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }}
            />
            <FaCalendar />
        </button>
    );
});

export default function InformePersonasRei(){
    const { token } = useAuth();
    const fecha = new Date();
    const { control, handleSubmit, watch, formState: { errors }} = useForm({
        defaultValues: { 
            FechaInicial: fecha, 
            FechaFinal: fecha
        }
    });
    const [filters, setFilters] = useState({
        tip_tipoidentificacion: '',
        per_sexo: '',
        min_minoria: '',
        dis_discapacidad: '',
        per_gestante: '',
        par_parentesco: '',
        per_terminal: '',
        per_resguardo: '',
        per_concomunitario: '',
        bar_barrio: '',
        bar_zonaid: '',
        bar_comunaid: '',
        usr_nombre: ''
    });
    const [Cargando, setCargando] = useState(false);
    const [datospersona, setDatospersona] = useState([]);
    const [swalProps, setSwalProps] = useState();
    
    const onSubmit = (data) => {
        fetchData(
            data.FechaInicial.toLocaleDateString('en-CA'),
            data.FechaFinal.toLocaleDateString('en-CA')
        );
    };
    async function fetchData (FechaI, FechaF) {
        const url = `/reincorporados/generarinformepersonas?FechaInicio=${FechaI}&FechaFinal=${FechaF}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatospersona(result);
        } catch (error) {
            if (error.response && error.response.status === 409) {
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: error.response.data.message || 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            } else {
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la informaci&oacute;n de personas.',
                    showConfirmButton: true,
                });
            }
        } finally {
            setCargando(false);
        }
    };
    async function exportarCSV() {
        setCargando(true);
        const FechaI = watch('FechaInicial').toLocaleDateString('en-CA')
        const FechaF = watch('FechaFinal').toLocaleDateString('en-CA')
        const url = `/reincorporados/generarinformepersonas?FechaInicio=${FechaI}&FechaFinal=${FechaF}&csv=${true}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            const csvData = result.map(row => ({
                'Tipo documento': row.tip_tipoidentificacion,
                'Identificacion': row.per_idpersona,
                'Primer Nombre': row.per_nombre1,
                'Segundo Nombre': row.per_nombre2,
                'Primer Apellido': row.per_apellido1,
                'Segundo Apellido': row.per_apellido2,
                'Edad': row.per_edad,
                'Sexo': row.per_sexo,
                'Fecha Registro SIPOD': row.per_fecharegistrosipod,
                'Tipo de Entrega': row.tip_tipoentrega,
                'Tipo AH': row.tip_tipoahu,
                'Tipo Naturaleza': row.tip_tiponaturaleza,
                'Naturaleza Entrega': row.tip_naturaleza,
                'Ayuda': row.ayu_ayuda,
                'Producto': row.tip_atencion,
                'Entidad': row.ent_entidad,
                'Fecha': row.det_fecha,
                'Hora': row.det_horaatencion,
                'Cantidad': row.det_cantidad,
                'Valor': row.det_valor,
                'Usuario': row.usr_nombre,
                'Observaciones': row.det_observaciones,
                'Fecha creacion': row.det_creacionsistema,
                'Sede': row.det_sede,
                'Telefono 2': row.cab_telefono1,
                'Telefono 1': row.cab_telefono2,
                'Discapacidad': row.dis_discapacidad,
                'OSIEGD': row.per_lgtbi,
                'Gestante': row.per_gestante,
                'Minoria': row.min_minoria,
                'Enf. Terminal': row.per_terminal,
                'Resguardo': row.per_resguardo,
                'Con.Comunitario': row.per_concomunitario,
                'Asiste Escuela': row.per_asisteescuela,
                'Asistia Escuela': row.per_asistiaescuela,
                'Tipo Estudio': row.tip_descripcion,
                'Autos de la Corte': row.tip_tipoauto,
                'Ultimo Grado': row.per_ultimogrado,
                'Direccion': row.cab_direccion,
                'Barrio': row.bar_barrio,
                'Asentamiento': row.ase_asentamiento,
                'Zona': row.zon_zona,
                'Comuna': row.comuna,
                'Fecha Nacimiento': row.fechanac,
                'Cabeza de Hogar': row.gru_idcabezafamilia,
                'Id detalle': row.iddetalleatencion
            }));
            const blob = new Blob([Papa.unparse(csvData, { delimiter: '|' })], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'InformeAyudas.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }

    // Get unique values for filters from datospersona
    const uniqueValues = (key) => [...new Set(datospersona.map(row => row[key]).filter(Boolean))];

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;

    // Filtered data based on filters
    const filteredData = datospersona.filter(row =>
        (!filters.tip_tipoidentificacion || row.tip_tipoidentificacion === filters.tip_tipoidentificacion) &&
        (!filters.per_sexo || row.per_sexo === filters.per_sexo) &&
        (!filters.min_minoria || row.min_minoria === filters.min_minoria) &&
        (!filters.dis_discapacidad || row.dis_discapacidad === filters.dis_discapacidad) &&
        (!filters.per_gestante || row.per_gestante === filters.per_gestante) &&
        (!filters.par_parentesco || row.par_parentesco === filters.par_parentesco) &&   
        (!filters.per_terminal || row.per_terminal === filters.per_terminal) &&
        (!filters.per_resguardo || row.per_resguardo === filters.per_resguardo) &&
        (!filters.per_concomunitario || row.per_concomunitario === filters.per_concomunitario) &&
        (!filters.bar_barrio || row.bar_barrio === filters.bar_barrio) &&
        (!filters.bar_zonaid || row.bar_zonaid === filters.bar_zonaid) &&
        (!filters.bar_comunaid || row.bar_comunaid === filters.bar_comunaid) &&
        (!filters.usr_nombre || row.usr_nombre === filters.usr_nombre)
        // Add more filter conditions as needed
    );

    // Pagination logic
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    // Handler for page change
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    // Reset to first page when filters change
    React.useEffect(() => {
        setCurrentPage(1);
    }, [filters, datospersona]);

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Informe reincorporados personas</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/caracterizacion/informesadministrativos" > Administrativos</NavLink></li>
                        <li className="breadcrumb-item active"> Informe reincorporados personas</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuAdministrativosRei/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-header' style={{display: 'flex', justifyContent: 'flex-end', textAlign: 'right',}}> 
                                    <ButtonsMenu data={filteredData} titulo={'Informe personas'} exportarCSV={exportarCSV}/>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Container>
                                            
                                            <ButtonGroup aria-label="Basic example">
                                                <label htmlFor="FechaInicial">
                                                    <Controller
                                                        control={control}
                                                        name="FechaInicial"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                    id="FechaInicial"
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </label>
                                                {errors.FechaInicial && <p style={{color: 'red'}}>Fecha inicial</p>}
                                                <label htmlFor="FechaFinal">
                                                    <Controller
                                                        control={control}
                                                        name="FechaFinal"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                    id="FechaFinal"
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.FechaFinal && <p style={{color: 'red'}}>Fecha final</p>}
                                                </label>
                                                <button
                                                    type="submit"
                                                    className="img-square elevation-1"
                                                    style={{
                                                        fontSize: '0.7rem',
                                                        padding: '2px 12px',
                                                        height: 38,
                                                        minWidth: '80px',
                                                        verticalAlign: 'middle',
                                                        border: '1px solid #6daff1ff',
                                                        borderRadius: 4,
                                                        background: '#abbdcfff',
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                    data-tooltip-id='tooltiparriba'
                                                    data-tooltip-content="Consultar"
                                                >
                                                    <FaSearch /> Buscar
                                                </button>
                                            </ButtonGroup>
                                        </Container>
                                    </form>
                                </div>
                                {datospersona && datospersona.length > 0 && <div className="card-body table-responsive p-0">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0' }}>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Anterior
                                        </button>
                                        <span style={{ margin: '0 1rem' }}>
                                            Página {currentPage} de {totalPages}
                                        </span>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Tipo documento</th>
                                                <th>idpersona</th>
                                                <th>Nombre1</th>
                                                <th>Nombre2</th>
                                                <th>Apellido1</th>
                                                <th>Apellido2</th>
                                                <th>fechanacimiento</th>
                                                <th>Sexo</th>
                                                <th>Discapacidad</th>
                                                <th>etnia</th>
                                                <th>Iden. Cabeza</th>
                                                <th>Telefono 1</th>
                                                <th>Telefono 2</th>
                                                <th>Parentesco</th>
                                                <th>Gestante</th>
                                                <th>Edad</th>
                                                <th>Enf. Terminal</th>
                                                <th>Resguardo</th>
                                                <th>Con.Comunitario</th>
                                                <th>Asiste Escuela</th>
                                                <th>Asistia Escuela</th>
                                                <th>Tipo Estudio</th>
                                                <th>Autos de la Corte</th>
                                                <th>Ultimo Grado</th>
                                                <th>Direccion</th>
                                                <th>No. Declaracion</th>
                                                <th>Barrio</th>
                                                <th>Asentamiento</th>
                                                <th>Zona</th>
                                                <th>Comuna</th>
                                                <th>Fecha Creacion</th>
                                                <th>Estado Civil</th>
                                                <th>Ingresos</th>
                                                <th>Creado Por</th>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <select
                                                        value={filters.tip_tipoidentificacion}
                                                        onChange={e => setFilters(f => ({ ...f, tip_tipoidentificacion: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('tip_tipoidentificacion').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.per_sexo}
                                                        onChange={e => setFilters(f => ({ ...f, per_sexo: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('per_sexo').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.dis_discapacidad}
                                                        onChange={e => setFilters(f => ({ ...f, dis_discapacidad: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('dis_discapacidad').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.min_minoria}
                                                        onChange={e => setFilters(f => ({ ...f, min_minoria: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('min_minoria').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.par_parentesco}
                                                        onChange={e => setFilters(f => ({ ...f, par_parentesco: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('par_parentesco').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_gestante}
                                                        onChange={e => setFilters(f => ({ ...f, per_gestante: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('per_gestante').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.per_terminal}
                                                        onChange={e => setFilters(f => ({ ...f, per_terminal: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('per_terminal').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_resguardo}
                                                        onChange={e => setFilters(f => ({ ...f, per_resguardo: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('per_resguardo').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_concomunitario}
                                                        onChange={e => setFilters(f => ({ ...f, per_concomunitario: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('per_concomunitario').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.bar_barrio}
                                                        onChange={e => setFilters(f => ({ ...f, bar_barrio: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('bar_barrio').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.bar_zonaid}
                                                        onChange={e => setFilters(f => ({ ...f, bar_zonaid: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('bar_zonaid').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.bar_comunaid}
                                                        onChange={e => setFilters(f => ({ ...f, bar_comunaid: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('bar_comunaid').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.usr_nombre}
                                                        onChange={e => setFilters(f => ({ ...f, usr_nombre: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('usr_nombre').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{row.tip_tipoidentificacion}</td>
                                                    <td>{row.per_idpersona}</td>
                                                    <td>{row.per_nombre1}</td>
                                                    <td>{row.per_nombre2}</td>
                                                    <td>{row.per_apellido1}</td>
                                                    <td>{row.per_apellido2}</td>
                                                    <td>{row.fechanac}</td>
                                                    <td>{row.per_sexo}</td>
                                                    <td>{row.dis_discapacidad}</td>
                                                    <td>{row.min_minoria}</td>
                                                    <td>{row.gru_idcabezafamilia}</td>
                                                    <td>{row.cab_telefono1}</td>
                                                    <td>{row.cab_telefono2}</td>
                                                    <td>{row.par_parentesco}</td>
                                                    <td>{row.per_gestante}</td>
                                                    <td>{row.per_edad}</td>
                                                    <td>{row.per_terminal}</td>
                                                    <td>{row.per_resguardo}</td>
                                                    <td>{row.per_concomunitario}</td>
                                                    <td>{row.per_asisteescuela}</td>
                                                    <td>{row.per_asistiaescuela}</td>
                                                    <td>{row.tip_estudiodescripcion}</td>
                                                    <td>{row.tip_tipoauto}</td>
                                                    <td>{row.per_ultimogrado}</td>
                                                    <td>{row.cab_direccion}</td>
                                                    <td>{row.cab_nodeclaracion}</td>
                                                    <td>{row.bar_barrio}</td>
                                                    <td>{row.cab_asentamientoid}</td>
                                                    <td>{row.bar_zonaid}</td>
                                                    <td>{row.bar_comunaid}</td>
                                                    <td>{row.per_fechacreacionsistema}</td>
                                                    <td>{row.est_estadocivil}</td>
                                                    <td>{row.per_ingresos}</td>
                                                    <td>{row.usr_nombre}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}